module.exports = __webpack_public_path__ + "media/images/homes/Backofhouse2x-d4546d4621a1ddcfc6cd9046e10a76c0.png";